import React, { useEffect } from "react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import {
  BRANDS_LIST,
  getMinioImage,
  getTopColorsFromImages,
  getTopColorsFromMultipleUrls,
} from "../../../utils/helpers";
import Img from "../../../components/Img";
import AbLogo2 from "../../../assets/logo192.png";

import AbLogo from "../../../assets/ablogo-round-whiteBg.png";
import { Icon } from "@iconify/react";
import { color } from "framer-motion";
import grid from "../../../assets/public-dotted-grid.png";
import watermark from "../../../assets/water.png";
import ImgOptimized from "../../../components/ImgOptimized";
import classNames from "classnames";
import renderImg from "../../../assets/materialIntro.jpg";
import { Box } from "@chakra-ui/react";

const MoodboardView = ({ data }) => {
  // console.log(data);
  //  const [colors, setColors] = useState([]);

  // useEffect(() => {
  //   (async () => {
  //     const result = await getTopColorsFromMultipleUrls(imgArray);
  //     setColors(result);
  //   })();
  // }, [imgArray]);
  // getTopColorsFromMultipleUrls(data["Reception"].map(v => getMinioImage(v))).then(data => console.log(data)).catch(err => console.error("Error fetching top colors", err));
  // getTopColorsFromImages(data["Reception"].map(v=>getMinioImage(v))).then(data=> console.log(data)).catch(err=> console.error("Error fetching top colors", err));
  return (
    <div className="space-y-8 mt-4">
      {Object.entries(data).map(([key, images]) => (
        <SingleSection key={key} heading={key} images={images} />
      ))}
    </div>
  );
};

export const SingleSection = ({
  heading,
  zone,
  images = [],
  materials = [],
  isPublicView,
  selectedImage,
  isPdfView,
  isPdf,
  selectedMaterialImg,
  isEdit = false,
  handleDeleteMaterial,
  metaDescriptions,
  skus = [],
  brands = [],
  isViewByZone = false,
  renderImage = null,
  showZoneLabel = false,
}) => {
  // console.log({images, skus})
  console.log({ images, skus, brands, heading, zone, materials });

  const [isImagesLoaded, setIsImagesLoaded] = React.useState(false);

  useEffect(() => {
    // Simply mark images as loaded
    setIsImagesLoaded(true);
  }, [images]);
  // console.log("SingleSection images:", images);
  // console.log("First image:", images?.[0]);
  // console.log(
  //   "Processed URL:",
  //   images?.[0] ? getMinioImage(images[0]) : "No image"
  // );
  const [colorPalettes, setColorPalettes] = React.useState([]);
  const getZoneLabel = (idx = 0) =>
    Array.isArray(zone) ? zone[idx] || "" : zone || "";

  useEffect(() => {
    if (isImagesLoaded && images && images.length > 0) {
      const imageUrls = images.map((v) => getMinioImage(v));
      // ? images.map((v) => getMinioImage(v))
      // : isPublicView && useBase64
      //   ? base64Images
      //   : images.map((v) => getMinioImage(v));

      if (imageUrls.length > 0) {
        getTopColorsFromMultipleUrls(imageUrls, 3)
          .then((data) => {
            setColorPalettes(data);
          })
          .catch((err) => {
            console.error("Error fetching top colors", err);
            // Fallback to empty array if color extraction fails
            setColorPalettes([]);
          });
      }
    }
  }, [images, isImagesLoaded, isPublicView, isPdf]);

  if (!images || images.length === 0) {
    return (
      <div className="bg-gray-100 p-4 rounded-xl flex h-[61vh]">
        <div className="flex items-center justify-center w-full">
          <p className="text-gray-500">No images available for {heading}</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`   overflow-hidden flex relative ${
        isPdf
          ? "h-[100svh] bg-white "
          : isPublicView
            ? "h-full bg-white "
            : "h-[61vh] bg-[#f5f5f5] "
      }`}
    >
      {isPublicView && (
        <ImgOptimized
          src={watermark}
          className="absolute top-1/2 opacity-30 -translate-x-1/2 pointer-events-none -translate-y-1/2  left-1/2 w-4/5 z-[50] "
          alt=""
        />
      )}

      {isViewByZone ? (
        /* ── isViewByZone UI (.bak) ── */
        <>
          <div className="flex justify-center items-center absolute top-0 left-1/2 -translate-x-1/2 w-fit px-6 py-2 pb-3 z-[100] rounded-b-3xl bg-white">
            <h2
              className={` ${
                isPdf ? "text-2xl " : "text-2xl xl:text-3xl"
              } font-bold  text-[#06565E] italic playfair capitalize`}
            >
              {heading}
            </h2>
          </div>
          <div className="absolute z-[10] -top-[14px] -left-[14px] w-[90px] rotate-45 aspect-square flex items-center justify-center rounded-r-full bg-white">
            <ImgOptimized src={AbLogo2} className=" w-[60px]  -rotate-45" />
          </div>
          <div className="basis-1/2 h-full flex flex-col mr-1 relative">
            <div className=" h-full  flex flex-col grow overflow-hidden relative min-h-0">
              <div className="basis-[50%] h-[50%] py-0 pb-[0px]  px-0   relative">
                <div className="grow min-h-0 w-full h-full  flex items-center justify-center overflow-hidden">
                  <ImgOptimized
                    src={getMinioImage(renderImage)}
                    className=" object-fill max-w-full max-h-full "
                  />
                </div>
                <div className="flex flex-col z-[50] absolute bottom-4 -right-2 gap-2 mt-4">
                  {colorPalettes.map((color, idx) => (
                    <div
                      key={idx}
                      className={`flex ${""} relative items-center gap-1 ${
                        isPublicView ? "bg-gray-100" : "bg-white"
                      }   p-0 rounded-full`}
                    >
                      <div
                        style={{ backgroundColor: color }}
                        className={`w-14 h-8 rounded-l-md text-[8px] flex items-center justify-center text-center text-white`}
                      >
                        {color}
                        {/* </span> */}
                      </div>
                    </div>
                  ))}
                </div>
                <div className="bg-[#06565E] px-3 py-2 rounded-tr-xl absolute bottom-0 left-0  text-[#EABC9D]">
                  <h2 className="italic playfair capitalize font-semibold lg:text-xl ">
                    Rendered
                  </h2>
                </div>
              </div>
              {/* Two images in a 2-column grid (index 0 and 1) */}
              <div className="basis-[50%] h-[50%] pt-[8px] w-full overflow-hidden grid grid-cols-2 gap-[8px]">
                {/* Image 0 */}
                <div className="relative flex items-center justify-center overflow-hidden bg-white">
                  {skus[0] && (
                    <div
                      className={`absolute top-2 left-2 z-10 bg-black/40 backdrop-blur-md text-white px-2 py-1 rounded-full text-xs `}
                    >
                      <span
                        className={classNames(
                          isPdfView ? "relative bottom-2 " : "",
                          "text-[10px]",
                        )}
                      >
                        {skus[0].length > 10
                          ? skus[0].substring(0, 10) + "..."
                          : skus[0]}
                      </span>
                    </div>
                  )}
                  {showZoneLabel ? (
                    getZoneLabel(0) ? (
                      <div className="absolute top-2 right-2 z-10 bg-black/40 backdrop-blur-md text-white px-2 py-1 rounded-full text-xs">
                        <span
                          className={classNames(
                            isPdfView ? "relative bottom-2 " : "",
                            "text-[10px]",
                          )}
                        >
                          {getZoneLabel(0)}
                        </span>
                      </div>
                    ) : null
                  ) : (
                    brands[0] &&
                    (() => {
                      const brandInfo = BRANDS_LIST.find(
                        (brand) => brand?._id === brands[0],
                      );
                      return brandInfo ? (
                        <div className="absolute top-2 right-2 z-10">
                          <ImgOptimized
                            src={brandInfo?.logo}
                            alt={brandInfo?._id}
                            className={
                              "h-8 max-w-16 object-contain " + brandInfo?.bg ||
                              ""
                            }
                          />
                        </div>
                      ) : null;
                    })()
                  )}
                  {materials[0]?.projects?.[0]?.quantity && (
                    <div className="absolute bottom-2 right-2 z-10 bg-black/40 backdrop-blur-md text-white px-2 py-1 rounded-full text-xs">
                      <span
                        className={classNames(
                          isPdfView ? "relative bottom-2 " : "",
                          "text-[10px]",
                        )}
                      >
                        Quantity : {materials[0]?.projects?.[0]?.quantity}
                        {materials[0]?.projects?.[0]?.uom
                          ? ` ${materials[0].projects[0].uom}`
                          : ""}
                      </span>
                    </div>
                  )}
                  {isImagesLoaded ? (
                    <DeleteImg
                      handleDeleteMaterial={() =>
                        handleDeleteMaterial(images[0])
                      }
                      isEdit={isEdit}
                    >
                      <ImgOptimized
                        src={getMinioImage(images[0])}
                        alt={`${heading}-main-image`}
                        className={`max-w-full max-h-full object-fit transition-all duration-300 ease-in-out ${
                          isPublicView ? "pointer" : "default"
                        } ${
                          selectedMaterialImg?.image == images[0] &&
                          selectedMaterialImg.heading == heading
                            ? "p-1 bg-teal-600"
                            : "hover:scale-105"
                        }`}
                        onClick={() => {
                          if (isPublicView) {
                            selectedImage(images[0]);
                          }
                        }}
                        cursor={isPublicView ? "pointer" : "default"}
                        onLoad={(e) => {
                          console.log(
                            "Image loaded successfully:",
                            e.target.src,
                          );
                        }}
                      />
                    </DeleteImg>
                  ) : (
                    <div className="w-full h-full flex items-center justify-center bg-gray-200">
                      <span className="text-gray-500">Loading image...</span>
                    </div>
                  )}
                </div>

                {/* Image 1 */}
                <div className="relative flex items-center justify-center overflow-hidden bg-white">
                  {skus[1] && (
                    <div
                      className={`absolute top-2 left-2 z-10 bg-black/40 backdrop-blur-md text-white px-2 py-1 rounded-full text-xs `}
                    >
                      <span
                        className={classNames(
                          isPdfView ? "relative bottom-2 " : "",
                          "text-[10px]",
                        )}
                      >
                        {skus[1].length > 10
                          ? skus[1].substring(0, 10) + "..."
                          : skus[1]}
                      </span>
                    </div>
                  )}
                  {showZoneLabel ? (
                    getZoneLabel(1) ? (
                      <div className="absolute top-2 right-2 z-10 bg-black/40 backdrop-blur-md text-white px-2 py-1 rounded-full text-xs">
                        <span
                          className={classNames(
                            isPdfView ? "relative bottom-2 " : "",
                            "text-[10px]",
                          )}
                        >
                          {getZoneLabel(1)}
                        </span>
                      </div>
                    ) : null
                  ) : (
                    brands[1] &&
                    (() => {
                      const brandInfo = BRANDS_LIST.find(
                        (brand) => brand?._id === brands[1],
                      );
                      return brandInfo ? (
                        <div className="absolute top-2 right-2 z-10">
                          <ImgOptimized
                            src={brandInfo?.logo}
                            alt={brandInfo?._id}
                            className={
                              "h-8 max-w-16 object-contain " + brandInfo?.bg ||
                              ""
                            }
                          />
                        </div>
                      ) : null;
                    })()
                  )}
                  {materials[1]?.projects?.[0]?.quantity && (
                    <div className="absolute bottom-2 right-2 z-10 bg-black/40 backdrop-blur-md text-white px-2 py-1 rounded-full text-xs">
                      <span
                        className={classNames(
                          isPdfView ? "relative bottom-2 " : "",
                          "text-[10px]",
                        )}
                      >
                        Quantity : {materials[1]?.projects?.[0]?.quantity}
                        {materials[1]?.projects?.[0]?.uom
                          ? ` ${materials[1].projects[0].uom}`
                          : ""}
                      </span>
                    </div>
                  )}
                  {isImagesLoaded ? (
                    images[1] ? (
                      <DeleteImg
                        handleDeleteMaterial={() =>
                          handleDeleteMaterial(images[1])
                        }
                        isEdit={isEdit}
                      >
                        <ImgOptimized
                          src={getMinioImage(images[1])}
                          alt={`${heading}-image-1`}
                          className={`max-w-full max-h-full object-fit transition-all duration-300 ease-in-out ${
                            isPublicView ? "pointer" : "default"
                          } ${
                            selectedMaterialImg?.image == images[1] &&
                            selectedMaterialImg.heading == heading
                              ? "p-1 bg-teal-600"
                              : "hover:scale-105"
                          }`}
                          onClick={() => {
                            if (isPublicView) {
                              selectedImage(images[1]);
                            }
                          }}
                          cursor={isPublicView ? "pointer" : "default"}
                          onLoad={(e) => {
                            console.log(
                              "Image loaded successfully:",
                              e.target.src,
                            );
                          }}
                        />
                      </DeleteImg>
                    ) : null
                  ) : (
                    <div className="w-full h-full flex items-center justify-center bg-gray-200">
                      <span className="text-gray-500">Loading image...</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="basis-1/2 ">
            <MasonryGrid
              images={[...images].splice(2, images.length)}
              isPublicView={isPublicView}
              isImagesLoaded={isImagesLoaded}
              selectedImage={selectedImage}
              selectedMaterialImg={selectedMaterialImg}
              heading={heading}
              isEdit={isEdit}
              handleDeleteMaterial={handleDeleteMaterial}
              skus={skus.slice(2)}
              brands={brands.slice(2)}
              materials={materials.slice(2)}
              isPdfView={isPdfView}
              zone={Array.isArray(zone) ? zone.slice(2) : zone}
              isViewByZone={isViewByZone}
              showZoneLabel={showZoneLabel}
            />
          </div>
        </>
      ) : (
        /* ── default UI (current) ── */
        <>
          <div className="basis-1/2 h-full flex flex-col mr-1 relative">
            <ImgOptimized
              src={grid}
              alt="grid"
              className="absolute top-0 left-0 w-[5.5vw] object-cover "
            />
            <ImgOptimized
              src={grid}
              alt="grid"
              className="absolute top-0 right-0 w-[5.5vw] object-cover "
            />

            <div className=" h-full  flex flex-col grow overflow-hidden ">
              <div className="basis-[25%] py-4  px-4  h-full">
                <div className="flex justify-between items-center ">
                  <div className="flex items-center gap-2  mb-4  grow">
                    <ImgOptimized src={AbLogo2} className="w-[60px]" />
                  </div>
                  <div className="w-[70%] shrink pl-4 flex flex-col gap-1">
                    <h2
                      className={` ${
                        isPdf ? "text-2xl " : "text-3xl"
                      } font-bold  text-[#06565E] italic playfair capitalize`}
                    >
                      {heading}
                    </h2>
                    <p
                      className={`text-[#06565E] italic ${
                        isPdfView ? "mb-4 text-base" : ""
                      } text-xs playfair`}
                    >
                      {metaDescriptions}
                    </p>
                  </div>
                </div>
                <div className="flex flex-col z-[50] absolute -top-3 -right-2 gap-2 mt-4">
                  {colorPalettes.map((color, idx) => (
                    <div
                      key={idx}
                      className={`flex ${""} relative items-center gap-1 ${
                        isPublicView ? "bg-gray-100" : "bg-white"
                      }   p-0 rounded-full`}
                    >
                      <div
                        style={{ backgroundColor: color }}
                        className={`w-14 h-8 rounded-l-md text-[8px] flex items-end justify-center text-center text-white`}
                      >
                        <span
                          className={classNames(
                            isPdfView ? "relative bottom-1 " : "",
                          )}
                        >
                          {color}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="basis-[75%] h-[50%] w-full  overflow-hidden bg-white relative flex items-center justify-center">
                {skus[0] && (
                  <div
                    className={`absolute top-2 left-2 z-10 bg-black/40 backdrop-blur-md text-white px-2 py-1 rounded-full text-xs `}
                  >
                    <span
                      className={classNames(
                        isPdfView ? "relative bottom-2 " : "",
                        "text-[10px]",
                      )}
                    >
                      {skus[0].length > 10
                        ? skus[0].substring(0, 10) + "..."
                        : skus[0]}
                    </span>
                  </div>
                )}
                <div className="absolute top-2 right-2 z-10 bg-black/40 backdrop-blur-md text-white px-2 py-1 rounded-full text-xs ">
                  <span
                    className={classNames(
                      isPdfView ? "relative bottom-2 " : "",
                      "text-[10px]",
                    )}
                  >
                    {getZoneLabel(0)}
                  </span>
                </div>
                {materials[0]?.projects?.[0]?.quantity && (
                  <div className="absolute bottom-2 right-2 z-10 bg-black/40 backdrop-blur-md text-white px-2 py-1 rounded-full text-xs">
                    <span
                      className={classNames(
                        isPdfView ? "relative bottom-2 " : "",
                        "text-[10px]",
                      )}
                    >
                      Quantity : {materials[0]?.projects?.[0]?.quantity}
                      {materials[0]?.projects?.[0]?.uom
                        ? ` ${materials[0].projects[0].uom}`
                        : ""}
                    </span>
                  </div>
                )}
                {isImagesLoaded ? (
                  <>
                    <DeleteImg
                      handleDeleteMaterial={() =>
                        handleDeleteMaterial(images[0])
                      }
                      isEdit={isEdit}
                    >
                      <ImgOptimized
                        src={getMinioImage(images[0])}
                        alt={`${heading}-main-image`}
                        className={`max-w-full max-h-full object-fit   transition-all duration-300 ease-in-out ${
                          isPublicView ? "pointer" : "default"
                        } ${
                          selectedMaterialImg?.image == images[0] &&
                          selectedMaterialImg.heading == heading
                            ? "p-1 bg-teal-600"
                            : "hover:scale-105"
                        }`}
                        onClick={() => {
                          if (isPublicView) {
                            selectedImage(images[0]);
                          }
                        }}
                        cursor={isPublicView ? "pointer" : "default"}
                        onLoad={(e) => {
                          console.log(
                            "Image loaded successfully:",
                            e.target.src,
                          );
                        }}
                      />
                    </DeleteImg>
                  </>
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-gray-200">
                    <span className="text-gray-500">Loading image...</span>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="basis-1/2 ">
            <MasonryGrid
              images={[...images].splice(1, images.length)}
              isPublicView={isPublicView}
              isImagesLoaded={isImagesLoaded}
              selectedImage={selectedImage}
              selectedMaterialImg={selectedMaterialImg}
              heading={heading}
              isEdit={isEdit}
              handleDeleteMaterial={handleDeleteMaterial}
              skus={skus.slice(1)}
              brands={brands.slice(1)}
              materials={materials.slice(1)}
              isPdfView={isPdfView}
              zone={Array.isArray(zone) ? zone.slice(1) : zone}
              isViewByZone={isViewByZone}
              showZoneLabel={showZoneLabel}
            />
          </div>
        </>
      )}
    </div>
  );
};

const MasonryGrid = ({
  images,
  isPublicView = false,
  isImagesLoaded = true,
  selectedImage,
  selectedMaterialImg,
  heading,
  isEdit,
  handleDeleteMaterial,
  skus = [],
  brands = [],
  materials = [],
  isPdfView = false,
  zone = "",
  isViewByZone = false,
  showZoneLabel = false,
}) => {
  const getBrandInfo = (brandName) => {
    if (!brandName) return null;
    return BRANDS_LIST.find((brand) => brand?._id === brandName);
  };
  const getZoneLabel = (idx) =>
    Array.isArray(zone) ? zone[idx] || "" : zone || "";
  const gap = 12; // gap in px
  // images= [1,2,3,4,5,6]
  const evenImage = Math.floor(images.length / 2);
  const oddImages = images.length - evenImage;
  // console.log(oddImages, evenImage);
  const oddImagesHeight = {
    small: oddImages > 0 ? 60 / (oddImages - Math.floor(oddImages / 2)) : 100, // contains more images 1,5
    big: oddImages > 0 ? 40 / Math.floor(oddImages / 2) : 100, // contains less images 3,7
  };
  const evenImageHeight = {
    small: evenImage > 0 ? 55 / Math.floor(evenImage / 2) : 100, // contains more images 0,2
    big: evenImage > 0 ? 45 / (evenImage - Math.floor(evenImage / 2)) : 100, // contains less images
  };

  return (
    <div className="flex w-full   h-full ">
      <div className="basis-1/2 h-full">
        {images.map((img, idx) => {
          if (idx % 2 == 1) {
            return null;
          }
          //   idx = 0,2,4,6,8 (idx+1 = 1,3,5,7,9) so odd
          return (
            <div
              style={{
                width: "100%",
                height:
                  (idx / 2) % 2
                    ? `${oddImagesHeight.big}%`
                    : `${oddImagesHeight.small}%`,
                // height: "30%",
                // height: `${oddImagesHeight.small}%`,
                // border: "solid 1px black",
                overflow: "hidden",

                // marginBottom: `${gap}px`,
              }}
              className="overflow-hidden p-1 relative"

              //   className="bg-red-400"
            >
              {skus[idx] && (
                <div className="absolute top-2 left-2 z-10 bg-black/40 backdrop-blur-md text-white px-2 py-1 rounded-full text-xs ">
                  <span
                    className={classNames(
                      isPdfView ? "relative bottom-2 " : "",
                      "text-[10px]",
                    )}
                  >
                    {skus[idx].length > 10
                      ? skus[idx].substring(0, 10) + "..."
                      : skus[idx]}
                  </span>
                </div>
              )}
              {isViewByZone &&
                !showZoneLabel &&
                brands[idx] &&
                getBrandInfo(brands[idx]) && (
                  <div className="absolute top-2 right-2 z-10    ">
                    <ImgOptimized
                      src={getBrandInfo(brands[idx])?.logo}
                      alt={getBrandInfo(brands[idx])?._id}
                      className="h-8 max-w-16 object-contain"
                    />
                  </div>
                )}
              {(!isViewByZone || showZoneLabel) && (
                <div className="absolute top-2 right-2 z-10 bg-black/40 backdrop-blur-md text-white px-2 py-1 rounded-full text-xs ">
                  <span
                    className={classNames(
                      isPdfView ? "relative bottom-2 " : "",
                      "text-[10px]",
                    )}
                  >
                    {getZoneLabel(idx)}
                  </span>
                </div>
              )}
              {materials[idx]?.projects?.[0]?.quantity && (
                <div className="absolute bottom-2 right-2 z-10 bg-black/40 backdrop-blur-md text-white px-2 py-1 rounded-full text-xs">
                  <span
                    className={classNames(
                      isPdfView ? "relative bottom-2 " : "",
                      "text-[10px]",
                    )}
                  >
                    Quantity : {materials[idx]?.projects?.[0]?.quantity}
                    {materials[idx]?.projects?.[0]?.uom
                      ? ` ${materials[idx].projects[0].uom}`
                      : ""}
                  </span>
                </div>
              )}
              <div className=" overflow-hidden h-full w-full flex items-center justify-center">
                {isImagesLoaded ? (
                  <DeleteImg
                    isEdit={isEdit}
                    handleDeleteMaterial={() => handleDeleteMaterial(img)}
                  >
                    {/* <Box > */}

                    <ImgOptimized
                      src={
                        // isPublicView && useBase64
                        //   ? base64Images[idx]
                        //   :
                        getMinioImage(img)
                      }
                      alt={`masonry-img-${idx}`}
                      // width="100%"
                      // height="100%"
                      className={`object-fit max-w-full max-h-full    transition-all duration-300 ease-in-out ${
                        selectedMaterialImg?.image == img &&
                        selectedMaterialImg.heading == heading
                          ? "p-1 bg-teal-600"
                          : "hover:scale-105"
                      } `}
                      onClick={() => {
                        if (isPublicView) {
                          selectedImage(img);
                        }
                      }}
                    />
                    {/* </Box> */}
                  </DeleteImg>
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-gray-200">
                    <span className="text-gray-500 text-xs">Loading...</span>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
      <div className="basis-1/2 h-full">
        {images.map((img, idx) => {
          if (idx % 2 == 0) {
            return null;
          }
          //   idx = 1,3,5,7,9(idx+1 = 2,4,6,8) so even

          return (
            <div
              style={{
                width: "100%",
                height:
                  ((idx - 1) / 2) % 2
                    ? `${evenImageHeight.small}%`
                    : `${evenImageHeight.big}%`,
                // height: "30%",
                // height: `${oddImagesHeight.small}%`,
                // border: "solid 1px black",

                // marginBottom: `${gap}px`,
                overflow: "hidden",
              }}
              className="overflow-hidden p-1 relative"
              //   className="bg-red-400"
            >
              {skus[idx] && (
                <div className="absolute top-2 left-2 z-10 bg-black/40 backdrop-blur-md text-white px-2 py-1 rounded-full text-xs ">
                  <span
                    className={classNames(
                      isPdfView ? "relative bottom-2 " : "",
                      "text-[10px]",
                    )}
                  >
                    {skus[idx].length > 10
                      ? skus[idx].substring(0, 10) + "..."
                      : skus[idx]}
                  </span>
                </div>
              )}
              {isViewByZone &&
                !showZoneLabel &&
                brands[idx] &&
                (() => {
                  const brandInfo = BRANDS_LIST.find(
                    (brand) => brand?._id === brands[idx],
                  );
                  return brandInfo ? (
                    <div className="absolute top-2 right-2 z-10  ">
                      <ImgOptimized
                        src={brandInfo?.logo}
                        alt={brandInfo?._id}
                        className="h-8   max-w-16 object-contain"
                      />
                    </div>
                  ) : null;
                })()}
              {(!isViewByZone || showZoneLabel) && (
                <div className="absolute top-2 right-2 z-10 bg-black/40 backdrop-blur-md text-white px-2 py-1 rounded-full text-xs ">
                  <span
                    className={classNames(
                      isPdfView ? "relative bottom-2 " : "",
                      "text-[10px]",
                    )}
                  >
                    {getZoneLabel(idx)}
                  </span>
                </div>
              )}
              {materials[idx]?.projects?.[0]?.quantity && (
                <div className="absolute bottom-2 right-2 z-10 bg-black/40 backdrop-blur-md text-white px-2 py-1 rounded-full text-xs">
                  <span
                    className={classNames(
                      isPdfView ? "relative bottom-2 " : "",
                      "text-[10px]",
                    )}
                  >
                    Quantity : {materials[idx]?.projects?.[0]?.quantity}
                    {materials[idx]?.projects?.[0]?.uom
                      ? ` ${materials[idx].projects[0].uom}`
                      : ""}
                  </span>
                </div>
              )}
              <div className=" overflow-hidden h-full w-full flex items-center justify-center">
                {isImagesLoaded ? (
                  <DeleteImg
                    isEdit={isEdit}
                    handleDeleteMaterial={() => handleDeleteMaterial(img)}
                  >
                    <ImgOptimized
                      src={
                        // isPublicView && useBase64
                        //   ? base64Images[idx]
                        //   :
                        getMinioImage(img)
                      }
                      alt={`masonry-img-${idx}`}
                      // width="100%"
                      // height="100%"
                      className={`object-fit max-w-full max-h-full   transition-all duration-300 ease-in-out ${
                        selectedMaterialImg?.image == img &&
                        selectedMaterialImg.heading == heading
                          ? " p-1 bg-teal-600 "
                          : "hover:scale-105"
                      }`}
                      onClick={() => {
                        isPublicView && selectedImage(img);
                      }}
                    />
                  </DeleteImg>
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-gray-200">
                    <span className="text-gray-500 text-xs">Loading...</span>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const DeleteImg = ({ children, isEdit, handleDeleteMaterial }) => {
  if (!isEdit) return children;

  return (
    <div className="h-full w-full relative">
      {children}
      <div>
        <Icon
          icon="maki:cross"
          className="absolute top-1 right-1 text-white bg-black/50 p-1 rounded-full  cursor-pointer z-[100]"
          onClick={handleDeleteMaterial}
          width={16}
        />
      </div>
    </div>
  );
};

export default MoodboardView;
